import { render, staticRenderFns } from "./KybStatements.vue?vue&type=template&id=7981420a&scoped=true"
import script from "./KybStatements.vue?vue&type=script&lang=js"
export * from "./KybStatements.vue?vue&type=script&lang=js"
import style0 from "./KybStatements.vue?vue&type=style&index=0&id=7981420a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7981420a",
  null
  
)

export default component.exports